import axios from 'axios'
import router from '../router'
import qs from 'qs'
// 公共路径
import config from '../config'

// 在main.js设置全局的请求次数，请求的间隙
axios.defaults.retry = 4
axios.defaults.retryDelay = 3000
// axios.defaults.withCredentials = true
// axios.interceptors.response.use(undefined, function axiosRetryInterceptor (err) {
//   let config = err.config
//   // If config does not exist or the retry option is not set, reject
//   if (!config || !config.retry) return Promise.reject(err)

//   // Set the variable for keeping track of the retry count
//   config.__retryCount = config.__retryCount || 0

//   // Check if we've maxed out the total number of retries
//   if (config.__retryCount >= config.retry) {
//     // Reject with the error
//     return Promise.reject(err)
//   }

//   // Increase the retry count
//   config.__retryCount += 1

//   // Create new promise to handle exponential backoff
//   let backoff = new Promise(function (resolve) {
//     setTimeout(function () {
//       resolve()
//     }, config.retryDelay || 1)
//   })

//   // Return the promise in which recalls axios to retry the request
//   return backoff.then(function () {
//     return axios(config)
//   })
// })

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

const getApi = (url = '', params = {}) => {
  return new Promise((resolve, reject) => {
    let _params = params
    let token = ''
    if (window.localStorage.userData) {
      token = JSON.parse(window.localStorage.userData).token
    }
    _params.format = 'json'
    params.token = token
    axios.get(config.public_path + url, {params: _params}, {withCredentials: true})
      .then(data => {
        // console.log(3)
        if (data.data.code === 43003 || data.data.code === 50001) {
          router.push({
            name: 'Login',
            query: {
              type: '1'
            }
          })
          window.localStorage.removeItem('userData')
          resolve()
        } else if (data.data.code === 0) {
          resolve(data.data)
        } else {
          resolve(data.data)
        }
      })
      .catch(err => {
        // console.log(2)
        console.log(err)
        // router.push('/error')
        resolve(null)
      })
  })
}

const postApi = (url = '', params = {}) => {
  return new Promise((resolve, reject) => {
    let _params = params
    let token = ''
    if (window.localStorage.userData) {
      token = JSON.parse(window.localStorage.userData).token
    }
    _params.format = 'json'
    params.token = token
    // console.log(config.public_path + url)
    axios.post(config.public_path + url, qs.stringify(params))
      .then(data => {
        if (data.data.code === 43003 || data.data.code === 50001) {
          router.push({
            name: 'Login',
            query: {
              type: '1'
            }
          })
          window.localStorage.removeItem('userData')
          resolve()
        } else if (data.data.code === 1) {
          resolve(data.data)
        } else {
          resolve(data.data)
        }
      })
      .catch(err => {
        console.log(err)
        resolve(null)
      })
  })
}

export {getApi, postApi}



// WEBPACK FOOTER //
// ./src/api/index.js